import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";
import type { OperatorWorkResponse } from "../../../shared/types";

export function useOperatorWork(brandId: string | undefined) {
  return useQuery({
    queryKey: ["operator-work", brandId],
    queryFn: () =>
      api.get<OperatorWorkResponse>(
        `/api/brands/${encodeURIComponent(brandId!)}/operator-work`,
      ),
    enabled: !!brandId,
  });
}

export type { OperatorWorkResponse } from "../../../shared/types";
